const initialState =
{
    data: [],
    saving: false,
};

export default (state = initialState, action) => {

    switch(action.type) {

        case 'OLDTICKETS_LIST':
            return {
                ...state,
                data: action.payload
            }
            break;

        default:
            return state;
    }
    
};


// WEBPACK FOOTER //
// ./src/reducers/oldtickets.js